<app-auth-chrome secondaryTitle="You are logged out">
  <button class="btn btn-block eim-button_noggin" routerLink="/signin" data-test="logBackInButton">
    Log back in
  </button>
</app-auth-chrome>
